import { render, staticRenderFns } from "./SalesIndicators.vue?vue&type=template&id=1b75f87d&"
import script from "./SalesIndicators.vue?vue&type=script&lang=js&"
export * from "./SalesIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports